import Holidays from "../features/HolidayList/Holidays";

export const API_BASE_URL = process.env.REACT_APP_BASE_URL;

export const ENDPOINTS = {
  AUTH: {
    LOGIN: `/auth/login`,
    RELOGIN: `/auth/reLogin`,
    LOGOUT: `/auth/logout`,
    FORGOT_PASSWORD: `/auth/forgot-password2`,
    FORGOT_PASSWORD_MAIL: `/auth/forgot-password`,
    RESET_PASSWORD: `/auth/reset-password/`,
    PASSWORD_CONFIRM: `/auth/password-confirm`,
    REFRESH_TOKEN: `/auth/refresh-token`,
  },
  USER: {
    BASE: `/user`,
    ABOUT_ME: `/user/aboutme/`,
    PHOTO: `/user/photo/`,
    ADD_USER: `/user/addUser`,
    ADD_MULTIPLE_USERS: `/user/addMultipleUsers`,
    DELETE_USER: `/user/delete-user`,
    UPDATE_PASSWORD: `/user/updatePassword/`,
    UPLOAD_PHOTO: `/user/upload-photo/`,
    CANDIDATES: `/user/candidates/`,
    HRRMGMANAGERS: `/user/hrRmgManagers/`,
    FINDALLPEOPLE: `/user/findPeople/`,
    TOTAL_EMPLOYEES: `/user/total-employees`,
    ROLE_CHART: `/user/role-chart`,
  },
  EMPLOYEE: {
    BASE: `/employee`,
    PROFILE_BY_EMPCODE: `/employee/employee-profile/`,
    UPDATE_BY_EMPCODE: `/employee/update-profile/`,
    ADD_PROFILE_DATA: `/employee/add-profiledata/`,
    EMPLOYEE_SEARCH: `/employee/search`,
    EMPLOYEE_SEARCH_NLP: `/employee/search-nlp`,
    TOP_TECHNOLOGY: `/employee/top-technologies`,
    BIRTHDAYS: `/employee/birthdays-thismonth`,
    NEWJOINEES: '/employee/new-joinees',
    SHABASHWINNERS: '/employee/shabash-winners',
    WORK_ANNIVERSARY: '/employee/work-anniversary',
    GENDER_RATIO: `/employee/gender-ratio`,
    KRA_DETAILS: `/employee/kra/`,
    ALL_SKILLS: '/employee/skills/',
    ALL_TRAININGS: '/employee/trainings/',
    ALL_CERTIFICATES: '/employee/certificates/',
    NEW_SKILL: '/employee/skill/',
    NEW_TRAINING: '/employee/training/',
    NEW_CERTIFICATE: '/employee/certificate/',
    MASTER_DATA: '/employee/master-data',
    STATUS: '/employee/status/',
    TEAM: '/employee/getTeam/',
    HOLIDAYS: '/employee/holidays/',
    GET_EMPLOYEE_PROFILE: '/employee/fetchEmployeeProfile',
    CERTIFICATELIST: '/employee/certificates/',
  },
  COMMENT: {
    BASE: `/comment/`,
    BY_AUTHOR: `/comment/author/`,
    SPECIFIC: `/comment/`,
    DELETE_ALL: `/comment/deleteAll/`,
    PAUSE_ALL: `/comment/pauseAll/`,
  },
  CHAT: {
    BASE: `/chats/`,
    SEND: `/chats/send`,
    DELETE_ALL: `/chats/delete-all/`,
    PAUSE_ALL: `/chats/pause-all/`,
    PIN: `/chats/pin/`,
    UNPIN: `/chats/unpin/`,
  },
  FEEDBACK: {
    BASE: `/feedback/`,
    SUBMIT: '/feedback/submit',
    FETCH_ALL: '/feedback',
    UPDATE: '/feedback/',
    DELETE: '/feedback/',
    DELETE_ALL: `/feedback/delete-all/`,
  },
  ANNOUNCEMENT: {
    BASE: `/announcement/`,
    SPECIFIC: `/announcement/`,
    DELETE_ALL: `/announcement/delete-all/`,
    PAUSE_ALL: `/announcement/pause-all/`,
    PIN: `/announcement/pin/`,
    UNPIN: `/announcement/unpin/`,
  },

  EVENTS: {
    BASE: '/',
    GET_ALL_EVENTS: '/events',
    GET_EVENT_BY_ID: '/events/',
    POST_EVENT: '/events',
    UPDATE_EVENT: '/events/',
    DELETE_EVENT: '/events/',
  },

  GNN: {
    BASE: '/',
    GET_ALL_NEWS: '/gnn/',
    GET_NEWS_BY_ID: '/gnn/detail/',
    POST_NEWS: '/gnn',
    UPDATE_NEWS: '/gnn/',
    DELETE_NEWS: '/gnn/',
    LIKE_NEWS: '/gnn/:id/like',
    UNLIKE_NEWS: '/gnn/:id/like',
    COMMENT_NEWS: '/gnn/:id/comment',
    DELETE_COMMENT: '/gnn/:id/comment/',
    VIEW_NEWS: '/gnn/:id/view',
    MARK_AS_TOP_5: '/gnn/markAsTop5/',
    TRENDING_NEWS: 'gnn/trending-news',
    TOP_NEWS: 'gnn/top-news',
    NEW_OPENINGS: 'gnn/new-openings',
  },

  SHABASH: {
    BASE: `/shabash/`,
    BY_NOMINATOR: `/shabash/nominator/`,
    BY_NOMINEE: `/shabash/nominee/`,
    SEARCH: '/shabash/search',
    GET_YEARS: `/shabash/years`,
    GET_WINNERS_BY_YEAR: `/shabash/byYear`,
    UPDATE_STATUS: `/shabash/updateAdminStatus/`,
  },
  RNR: {
    BASE: `/rnr/`,
    START_QUARTER: `/rnr/start-quarter`,
    ADD_NOMINATION: `/rnr/`,
    SET_WINNER: `/rnr/set-winner`,
    GET_BY_QUARTER_AND_YEAR: `/rnr/quarterAndYear/`,
    UPDATE_NOMINATION: `/rnr/update/`,
    DELETE_NOMINATION: `/rnr/delete/`,
    GET_ALL_NOMINATIONS: `/rnr/`,
    GET_NOMINATION_BY_ID: `/rnr/nomination/`,
    GET_WINNER_BY_EMPCODE: `/rnr/winners/`,
    GET_HISTORICAL_NOMINATIONS: `/rnr/historical`,
    GET_ALL_WINNERS: `/rnr/winners`,
    GET_NOMINATIONS_BY_CATEGORY: `/rnr/category/`,
    DEACTIVATE_QUARTER: `/rnr/deactivate/`,
    GET_ACTIVE_QUARTER: `/rnr/active-quarter`,
    GET_PREVIOUS_CLOSED_QUARTER: `/rnr/previous-closed-quarter`,
    GET_NOMINATION_BY_NOMINEE_EMPCODE: `/rnr/nomination/`,
    GET_YEARS: `/rnr/years`,
  },
  INTERNAL_PROGRAM: {
    BASE: `/internalProgram`,
    RNR: `/internalProgram/rnr`,
    SABASH: `/internalProgram/sabash`,
  },
  NOMINATION: {
    BASE: `/nomination`,
    BY_ID: `/nomination/`,
    BY_NOMINEE: `/nomination/byNominee/`,
    BY_NOMINATOR: `/nomination/byNominator/`,
    BY_PROGRAM: `/nomination/byProgram/`,
    DELETE_ALL: `/nomination/deleteAll/`,
    UPDATE_ADMIN_STATUS: `/nomination/updateAdminStatus/`,
    PAUSE_ALL: `/nomination/pauseAll/`,
    DELETE: `/nomination/delete/`,
    PENDING_RNR: `/nomination/pending/`,
    TOTAL_SABASH: `/nomination/totalsabash/`,
  },
  GIFT_FORM: {
    BASE: `/gift-form`,
    CHECK_ELIGIBILITY: `/gift-form/check`,
    GET_MY_FORMS: `/gift-form`,
    GET_JUNIOR_FORMS: `/gift-form/junior`,
    GET_ALL_FORMS: `/gift-form/all`,
    CREATE_GIFT_FORM: `/gift-form`,
    CHANGE_STATUS: '/gift-form/:id/status',
    GET_GIFT_INTERVIEWS: '/gift-form/interview',
    SUBMIT_FEEDBACK: '/gift-form/interview/feedback',
  },
  PERMISSIONS: {
    BASE: '/module',
    GET_USER_PERMISSIONS: '/module/user-permission/',
    SET_SINGLE_USER_PERMISSIONS: '/module/user-permission-single',
    SET_USERS_PERMISSIONS: '/module/user-permission',
    REVOKE_USERS_PERMISSIONS: '/module/user-permission-revoke',
    GET_MODULES: '/module',
    ADD_FEATURE: '/module/feature',
    REVOKE_SINGLE_USER_PERMISSIONS: '/module/user-permission-revoke-single',
  },
  DELIGHT: {
    BASE: `/delights`,
    REQUEST: `/delights/request`,
    BY_REQUESTER: `/delights/byRequesterId/`,
    DELETE_ALL: `/delights/deleteAll/`,
    UPDATE_ADMIN_STATUS: `/delights/updateAdminStatus/`,
    UPDATE_HR_STATUS: `/delights/updateHrStatus/`,
    PAUSE_ALL: `/delights/pauseAll/`,
    DELETE: `/delights/delete/`,
    PENDING: `/delights/pending/`,
  },
  RESUME: {
    BASE: `/resume`,
    BY_EMPLOYEE: `/resume/`,
    GENERATE: `/resume/generate`,
    EXPORT: `/resume/export/`,
    UPDATE: `/resume/`,
    PROFILE_STRENGTH: `/resume/profile-strength/`,
  },

  SETTINGS: {
    BASE: `/settings`,
    TOGGLE_COMMENTS_PAUSE: `/settings/toggleCommentsPause`,
    TOGGLE_DELIGHTS_PAUSE: `/settings/toggleDelightsPause`,
    TOGGLE_GIFT_FORM_PAUSE: `/settings/toggleGiftFormPause`,
    TOGGLE_RNR_PAUSE: `/settings/toggleRnRPause`,
    TOGGLE_SABASH_PAUSE: `/settings/toggleSabashPause`,
    GET_SETTINGS: `/settings/getSettings`,
  },

  UTILS: {
    LINK_PREVIEW: `/utils/link-preview`,
  },

  PUBLIC: {
    LOGO: `/logos/`,
    PHOTO: `/uploads/`,
    GNN: `/public/`,
  },

  VENDOR: {
    BASE: `/eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9`,
    ADDSCANNEDDATA: `/eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9/addScannedData`,
    ADDSNACKS: `/eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9/addSnacks`,
    GETDATAOFDATERANGE: `/eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9/getDataOfDateRange`,
    GETSCANNEDDATABYDATE: `/eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9/getScannedDataByDate`,
    GETSNACKS: `/eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9/getSnacks`,
    GERREGIONSNACKS: `/eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9/getRegionSnacks`,
    ADDREGIONSNACKS: `/eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9/addRegionSnacks`,
  },

  REFERSHMENTS: {
    BASE: `/refreshments`,
    GETSCANNEDDATA: `/refreshments/getScannedData`,
    GETSNACKS: `/refreshments/getSnacks`,
    GETCONFIG: `/refreshments/getConfig`,
    GETSCANNEDDATABYEMPID: `/refreshments/getScannedData`,
    ADDCONFIG: `/refreshments/addConfig`,
    ADDREVIEW: `/refreshments/addReview`,
    GETREVIEWBYEMPID: `/refreshments/getReviewByEmpId`,
    GETREVIEWBYDATERANGE: `/refreshments/getReviewByDateRange`,
    ADDVOTE: `/refreshments/addVote`,
    GETVOTE: `/refreshments/getVote`,
    GETREGIONBYEMPID:'/refreshments/getRegionByEmpId'

  },
  ATTENDANCE: {
    BASE: `/eventAttendance`,
    GETATTENDANCE: `/eventAttendance/getAttendance`,
    ADDATTENDANCE: `/eventAttendance/addAttendance`
  },

  FCMTOKEN: {
    BASE: `/fcm`,
    ADDFCMTOKEN: `/fcm/addToken`,
    GETFCMTOKEN: `/fcm/getToken`,
    REMOVEFCMTOKEN: `/fcm/removeToken`,
  },
  VERSION: {
    BASE: `/version`,
    ADDVERSION: `/version/addVersion`,
    GETVERSION: `/version/getVersion`,
  },
};
